import { useEffect, useState } from "react";
import { instanceV2 } from "../api";

let cachedRate = 0;
let inflight = null;

export default function useUsdKzt() {
    const [rate, setRate] = useState(cachedRate);

    useEffect(() => {
        if (cachedRate) return undefined;
        if (!inflight) {
            inflight = instanceV2()
                .get("/fx/usd-kzt")
                .then((r) => (r.data?.ok ? Number(r.data.rate) || 0 : 0))
                .catch(() => 0);
        }
        let alive = true;
        inflight.then((v) => {
            cachedRate = v;
            if (!v) inflight = null;
            if (alive) setRate(v);
        });
        return () => {
            alive = false;
        };
    }, []);

    return rate;
}

export const fmtKzt = (usd, rate) =>
    rate > 0 ? `${Math.round((Number(usd) || 0) * rate).toLocaleString("ru-RU")} ₸` : "";
